import { mapState, mapStores } from "pinia";
import { DropdownOption, NDropdown, NButton, SelectOption } from "naive-ui";
import { defineComponent, VNode, h } from "vue";
import { NavigationFailure } from "vue-router";

import { $t } from './../../i18n';

import { useDashboardStore } from "../../store/dashboard.store";
import { useStationStore } from "../../store/station.store";
import { useAuthStore } from "../../store/auth.store";
import { AvoltaTimeMode } from "../../configs/avolta-time-mode.config";


import DataSelector from '../data-selector/data-selector.vue';
import { useStationDetailStore } from "~/store/station-details.store";

export default defineComponent({

    components: {
        DataSelector,
        NDropdown,
        NButton,
    },

    props: {
        brandIcon: { type: String, default: require('@/avolta-connect-logo.png').default }
    },

    data() {
        return {
            showProfileMenu: false,
            showBurger: false,
            tenantIcon: this.brandIcon,
        }
    },

    computed: {
        ...mapStores(useAuthStore),
        ...mapState(useStationStore, ['groups', 'group']),
        ...mapState(useAuthStore, ['user']),

        query() {
            const query =  { mode: AvoltaTimeMode[0].name};
            if(this.$route.query?.group) {
                query['group'] = this.$route.query?.group;
            }
            
            return query;
        },

        userAvatar(): string {

            if(!this.user) {
                return '';
            }

            if (this.user && this.user.imageUrl) {
                return this.user.imageUrl;
            }

            const names: string[] = this.user.email.split('@')[0].split('.');

            if (names.length === 0) {
                return this.buildUiAvatarUrl('John', 'Doe');
            }

            if (names.length === 1) {
                return names[0].length >= 2 ? this.buildUiAvatarUrl(names[0].charAt(0), names[0].charAt[1]) : this.buildUiAvatarUrl('John', 'Doe');
            }

            return this.buildUiAvatarUrl(names[0], names[1]);
        },

        options(): DropdownOption[] {
            const options: DropdownOption[] = [
                {
                    label: this.user?.username || '',
                    key: 'username',
                    value: 'username',
                    disabled: true
                },
                {
                    key: 'preferences',
                    value: 'preferences',
                    label: $t('headbar.my_account')
                }
            ];

            options.push(
                {
                    label: $t('headbar.disconnect'),
                    value: 'disconnect',
                    key: 'disconnect',
                }
            )

            return options;
        }
    },

    async mounted(): Promise<void> {
        if(this.authStore.isLogged) {
            this.authStore.fetchUser();
        }
    },

    methods: {

        handleSelect(a, selected: SelectOption): void {
            switch(selected?.key) {
                case 'disconnect':
                    this.logout();
                    break;
                case 'preferences':
                    this.$router.push({ name: 'preferences'});
                    break;
                case 'username':
                    this.$router.push({ name: 'preferences'});
                    break;

            }
        },

        logout(): Promise<void | NavigationFailure> {
            this.showBurger = false;
            return this.authStore.logout().then(() => {
                useStationStore().$reset();
                useDashboardStore().$reset();
                useStationDetailStore().$reset();
                return this.$router.push('/login');
            });
        },

        toggleUserProfileMenu(event: Event): void {
            event.stopPropagation();
            this.showProfileMenu = !this.showProfileMenu;
        },

        /**
         * Generate url for ui avatar.ui avatar generate url  
         * @param name 
         * @param surname 
         */
        buildUiAvatarUrl(name: string, surname: string): string {
            const regex = /[^a-zA-Z ]/g;
            return `https://ui-avatars.com/api/?name=${name.replace(regex, "")}${surname ? '+' + surname.replace(regex, ""): ''}&background=66BA7E&size=256&bold=true&color=ffff`;
        },

        renderDropdownIcon(icon: string): VNode {
            return h('span', { class: 'mdi'}, icon);
        }
    }
});